import axios from 'axios';
import { debug } from 'debug';
import { getReasonPhrase, StatusCodes } from 'http-status-codes';
import { HTTPRequestError } from '../../models/http';
import { PREDEF_ANSWERS_ROUTE } from '../configs/predef-answers-api';
import {
	PredefinedAnswerAction,
	PredefinedAnswersActionResponse,
	PredefinedAnswersDeleteRequest,
} from '../models/payload-parts';

export const deleteAnswer = async (
	payload: PredefinedAnswersDeleteRequest,
): Promise<PredefinedAnswerAction> => {
	const response = await axios.delete<PredefinedAnswersActionResponse>(
		PREDEF_ANSWERS_ROUTE.DELETE,
		{ data: payload },
	);

	if (response.status !== StatusCodes.OK) {
		debug(`Error: ${response.status}`);
		throw new HTTPRequestError(getReasonPhrase(response.status));
	}

	return response.data.responsePayload;
};
